import { render, staticRenderFns } from "./ChangeLog.modal.vue?vue&type=template&id=22cb145a&scoped=true"
import script from "./ChangeLog.modal.vue?vue&type=script&lang=ts"
export * from "./ChangeLog.modal.vue?vue&type=script&lang=ts"
import style0 from "./ChangeLog.modal.vue?vue&type=style&index=0&id=22cb145a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cb145a",
  null
  
)

export default component.exports